import React from 'react';
import './Tag.css';

export interface TagRowProps {
  /**
   * Tag components to display
   */
  children: React.ReactNode;
  /**
   * Layout mode: 'wrap' for flex-wrap, 'ribbon' for horizontal scroll
   * @default 'wrap'
   */
  mode?: 'wrap' | 'ribbon';
  /**
   * Optional className for custom styling
   */
  className?: string;
}

/**
 * TagRow - A container for Tag components
 * 
 * Supports two layout modes:
 * - 'wrap': Tags wrap to next line when they exceed container width
 * - 'ribbon': Tags scroll horizontally without wrapping
 * 
 * Gap between tags is 12px (spacing.px12).
 */
export const TagRow: React.FC<TagRowProps> = ({
  children,
  mode = 'wrap',
  className,
}) => {
  return (
    <div className={`spec-tag-row spec-tag-row--${mode} ${className || ''}`}>
      {children}
    </div>
  );
};

export default TagRow;
